import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CaseDetailV2 } from 'src/app/shared/common-structures/case-detail';
import { CaseDetailUtils } from 'src/app/shared/utility/caseDetailUtils';

@Component({
	selector: 'app-shared-systemic-search-cases-table',
	templateUrl: './shared-systemic-search-cases-table.component.html',
	styleUrls: ['./shared-systemic-search-cases-table.component.scss'],
})
export class SharedSystemicSearchCasesTableComponent implements OnInit {
	@Input() systemicCaseCharges: CaseDetailV2[];
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	displayColumns: string[] = [
		'ciChargeNumber',
		'rspName',
		'alStatuteShortName',
		'alBasisShortName',
		'alIssueShortName',
		'pchpAssessments',
		'ciAcctOfficeDescription',
		'chargeAssignments',
	];
	dataSource: MatTableDataSource<CaseDetailV2>;
	filters: any = {};

	constructor() {}

	ngOnInit(): void {
		this.setupMatTable();
	}

	/**
	 * @description Setup matTable. Including dataSource initialization, binding of paginator and sorter,
	 * and setup default sort.
	 */
	setupMatTable() {
		this.dataSource = new MatTableDataSource(this.systemicCaseCharges);
		this.dataSource.paginator = this.paginator;
	}

	public displayAllegations = CaseDetailUtils.displayAllegations;

	public displayPCHPAssessments = CaseDetailUtils.displayPCHPAssessments;

	public displayAssignedTo = CaseDetailUtils.displayAssignedTo;
}
